import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Button } from '../components/general/button/button';
import { Icon } from '../components/general/icon/icon';
import { FormsModule } from '@angular/forms';

export interface ConfirmationDialogData {
  heading: string;
  description: string;
  button_one: string;
  button_two: string;
  mode?: 'validation' | 'session-timeout';
  countdownEndAt?: number;
  supportingText?: string;
  supportingText2?: string;
}

@Component({
  selector: 'srp-confirmation-dialog',
   imports: [Button, MatDialogModule,Icon,  FormsModule],
  templateUrl: './confirmation-dialog.html',
  styleUrl: './confirmation-dialog.scss',
  
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialog implements OnInit, OnDestroy {
  selectedValidateVia: string = 'email';
  countdownDisplay = '';
  private countdownIntervalId: ReturnType<typeof setInterval> | null = null;

  get isSessionTimeoutMode(): boolean {
    return this.data.mode === 'session-timeout';
  }

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
    private readonly cdr: ChangeDetectorRef
  ){}

  ngOnInit(): void {
    if (!this.isSessionTimeoutMode || !this.data.countdownEndAt) {
      return;
    }

    this.updateCountdownDisplay();
    this.countdownIntervalId = setInterval(() => {
      this.updateCountdownDisplay();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.countdownIntervalId) {
      clearInterval(this.countdownIntervalId);
      this.countdownIntervalId = null;
    }
  }

  confirm(): void {
    if (this.isSessionTimeoutMode) {
      this.dialogRef.close(true);
      return;
    }

    console.log('selected in dialog', this.selectedValidateVia);

    if(!this.selectedValidateVia){
      return;
    }
    
    this.dialogRef.close(this.selectedValidateVia);
  }
  cancel():void {
    this.dialogRef.close(false);
  }

  private updateCountdownDisplay(): void {
    if (!this.data.countdownEndAt) {
      this.countdownDisplay = '';
      return;
    }

    const remainingMs = Math.max(0, this.data.countdownEndAt - Date.now());
    const remainingSeconds = Math.ceil(remainingMs / 1000);
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;
    this.countdownDisplay = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    this.cdr.markForCheck();
  }

}

